{
  "en": {
    "texts": {
      "user": {
        "maintainer": "Gets the maintainer badge and every supporter perk at the highest tier."
      },
      "index": "Your database for all information around Ships and Stations in Star Citizen.",
      "indexQuote": "“Strap into one of dozens of ships and embark on a life within the Star Citizen universe.<br>Unbound by profession or skill sets, you choose the path of your own life.”",
      "indexQuoteSource": "Author Unknown, Source:",
      "support": {
        "info": "Not spending? <a href=\"https://robertsspaceindustries.com/spectrum/community/SC/forum/57219/thread/fleetyards-net\" target=\"_blank\" rel=\"noopener\"><b>Upvote us on Spectrum</b></a> to help more people find FleetYards.",
        "goal": "Covers running costs like server hosting and data services.",
        "code": "New to Star Citizen? Use this code for 5000 UEC starting money:",
        "thisMonth": "of %{goal} this month",
        "subline": "Support us directly",
        "otherWays": "Other ways to help"
      },
      "installApp": {
        "eventSignup": "Install FleetYards as an app to get back to your events in one tap.",
        "iosIntro": "On iPhone and iPad, apps like FleetYards are installed from the share sheet:",
        "iosShare": "Tap the Share button in the browser toolbar.",
        "iosAdd": "Choose “Add to Home Screen”. You may have to scroll down to find it.",
        "iosConfirm": "Tap “Add”. FleetYards now opens from your Home Screen like any other app."
      },
      "supportHint": {
        "hangarSync": "Background syncs are the biggest item on our hosting bill. FleetYards runs on donations — if you'd like to chip in, every bit helps.",
        "vehicleAdded": "FleetYards is free and ad-free, and runs entirely on donations. If it's useful to you, a small contribution helps keep it that way.",
        "fleetCreated": "Fleets are one of our most resource-heavy features. FleetYards stays free and ad-free thanks to donations — consider chipping in.",
        "loginMilestone": "You've been around for a while — thank you. FleetYards runs on donations; if you'd like to help cover the bill, here's how.",
        "visitMilestone": "FleetYards is community-funded — no ads, no paywalls. If you find it useful, a small donation goes a long way."
      },
      "notFound": "You are currently venturing unknown space. In the event you are lost, the UEE highly recommends plotting a new destination back towards home-space.",
      "forbidden": "Your clearance does not cover this area. If a feature is still being rolled out, you can switch it on yourself under Settings > Features once it is available to you.",
      "subscriptionRequired": "Contracts, events, logistics and tours are kept running by the people who support FleetYards. This fleet isn't covered right now — a contribution from a single member opens all four for the whole fleet.",
      "featureNotReady": "This feature is not yet ready and will be available soon. Stay tuned!",
      "inviteInvalid": "This invite link is not valid. It may have been mistyped, it may have expired, or it may have already reached its limit of uses. Ask whoever invited you for a new link.",
      "accessDenied": "You are not authorized to view this page.",
      "serverError": "The server is currently experiencing technical difficulties. Please try again later.",
      "offline": "The request never reached the server. Your device appears to be offline, or the server could not be reached. Check your connection and try again.",
      "invalidRequest": "The server could not process this request. Reload the page and try again.",
      "invalidListRequest": "This filter or sort isn't valid. Reset it to show the list again.",
      "compare": {
        "ships": {
          "info": "To start select at least two and not more than eight Ships you want to compare."
        }
      },
      "fleets": {
        "leaveInfo": "You can not leave the Fleet.",
        "directory": "Verified fleets that chose to be found. Every fleet here has proved it runs its RSI organisation."
      },
      "admin": {
        "destroyedFleets": {
          "purgedWarning": "Restoring a purged fleet is best-effort. Roles, images, invite links and fleet vehicles are not restored."
        },
        "models": {
          "viewsFolder": {
            "hint": "Drop a folder of views named top.png, side.png, front.png and angled.png. Suffix _colored for the painted set, prefix extended_ for the extended one and landed_ for the landed one. A flight_ prefix, or none at all, goes to the default set. holo.gltf comes along too, with the same prefixes.",
            "uploading": {
              "one": "Uploading one file…",
              "other": "Uploading %{count} files…"
            },
            "matched": {
              "one": "One file ready — save to apply it.",
              "other": "%{count} files ready — save to apply them."
            },
            "processing": {
              "one": "Cropping one view in the background — it updates here when done.",
              "other": "Cropping %{count} views in the background — they update here when done."
            },
            "processed": "All views are processed.",
            "ignored": "Ignored: %{files}"
          }
        },
        "oauthApplications": {
          "rejectHint": "The reason is shown to whoever registered the application, so name what has to change."
        }
      },
      "hangarTour": {
        "welcome": {
          "title": "Welcome to your hangar",
          "text": "Your hangar keeps track of every ship you own. This short tour shows where everything is — you can replay it from the ? button at any time."
        },
        "add": {
          "title": "Add ships",
          "text": "Pick one or more ships and how many of each. On any ship's page or card, the bookmark icon adds it to your hangar or wishlist too."
        },
        "sync": {
          "title": "Sync from RSI",
          "text": "Sync ships, paints, flair and equipment from RSI with the FleetYards browser extension. Review the result after each sync; buy-backs have their own sync on the Buy-backs page."
        },
        "display": {
          "title": "Display options",
          "text": "Switch between cards and a list, set your default order and pick which details or columns are shown. In the list you can select several ships at once and change them together."
        },
        "groups": {
          "title": "Groups",
          "text": "Sort your ships into groups of your own with + and the pen. Click a group to filter by it, hover it to highlight its ships."
        },
        "vehicle": {
          "title": "Each ship's menu",
          "text": "Edit a ship from here: name it, pick its paint, make it your flagship, set its visibility, manage loadouts or move it to your wishlist."
        },
        "wishlist": {
          "title": "Wishlist",
          "text": "Ships you want but do not own yet go on your wishlist. Move them to your hangar when you acquire them."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Line your ships up side by side to scale, and save the chart as an image."
        },
        "stats": {
          "title": "Stats",
          "text": "Roles, manufacturers, sizes and what you have spent, with a CSV export."
        },
        "share": {
          "title": "Share your hangar",
          "text": "Share your public hangar and choose which ships and groups appear. In Hangar settings, you can also create, replace or disable a secret link that works while your hangar is private. Anyone with that link can view your hangar and its stats."
        },
        "menu": {
          "title": "More",
          "text": "Import or export your hangar and check import history here. On a phone, this menu also holds the wishlist, fleetchart, stats, pledge items and this tour."
        },
        "overview": {
          "title": "Your ship’s own page",
          "text": "Click a ship’s title to open its overview to manage its configuration and visibility, write captain’s log entries and upload a picture. Give an owned ship a dedication plaque and save it as an image. Log entries have their own visibility settings."
        },
        "pledgeItems": {
          "title": "More than ships",
          "text": "Open Paints, Flair or Equipment from this menu to browse the items synced from your RSI hangar. Buy-backs are listed separately and can be synced from their own page."
        },
        "reset": {
          "title": "After an in-game wipe",
          "text": "Reset in-game ships from this menu: move them all to your wishlist to keep a shopping list, or remove them from your hangar. Pledged ships stay in place."
        },
        "inventories": {
          "title": "Hangar inventories",
          "text": "Track items at your locations, record deposits and withdrawals, and manage transfers from your hangar inventories."
        },
        "exampleShip": {
          "title": "Example ship",
          "text": "Only here for the guide. This ship is not saved to your hangar."
        }
      },
      "fleetTour": {
        "welcome": {
          "title": "Your fleet is ready",
          "text": "This tour opens each page that sets it up and points at the control that matters there. The question mark at the top of the fleet page brings it back any time."
        },
        "events": {
          "title": "Events and missions",
          "text": "Plan operations, let members sign up for a ship and a seat, and keep everything on the fleet calendar."
        },
        "contracts": {
          "title": "Contracts",
          "text": "Post jobs for your members and pay them out once they are done."
        },
        "members": {
          "title": "Invite members",
          "text": "Invite people by their Fleetyards username, or create an invite link to share on Discord or RSI. Requests to join land on this page too."
        },
        "ships": {
          "title": "Ships and fleetchart",
          "text": "The ships your members share add up to the fleet's ships. The fleetchart lines them up side by side to scale."
        },
        "membership": {
          "title": "Your ships in the fleet",
          "text": "Every member decides which of their ships the fleet sees: all of them, one hangar group or none. This is your own choice."
        },
        "rsi": {
          "title": "Verify your RSI organisation",
          "text": "Enter your organisation's SID and verify it. Verifying proves the organisation is yours and protects your fleet ID."
        },
        "roles": {
          "title": "Roles",
          "text": "Each role decides what its members may see and manage. This page lists what every role can do."
        },
        "squadrons": {
          "title": "Squadrons and teams",
          "text": "Switch squadrons on to split the roster into units and teams, each with ranks of its own."
        },
        "discord": {
          "title": "Connect Discord",
          "text": "Install the bot on your Discord server to give each rank a Discord role and mirror events as scheduled events."
        },
        "settings": {
          "title": "Public fleet page",
          "text": "Decide whether the fleet page and its ships are public; logo, description and links are on this page too."
        },
        "finish": {
          "title": "Your fleet is set up",
          "text": "That's everything to get started. The question mark up here brings this tour back any time."
        }
      },
      "hangarPreview": {
        "sync": {
          "title": "Sync from RSI",
          "text": "Import your pledges with the browser extension or a hangarXPLOR file instead of adding ships one by one."
        },
        "organise": {
          "title": "Organise your ships",
          "text": "Name your ships, set paints, loadouts and a flagship, and sort them into groups of your own."
        },
        "wishlist": {
          "title": "Wishlist and sales",
          "text": "Keep the ships you want on a wishlist and get notified when they go on sale."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "See your ships side by side to scale and save the chart as an image."
        },
        "stats": {
          "title": "Hangar stats",
          "text": "Roles, manufacturers, sizes and what you have spent, at a glance."
        },
        "share": {
          "title": "Public hangar",
          "text": "Share your hangar with a link — you decide which ships and groups are visible."
        }
      },
      "fleetPreview": {
        "members": {
          "title": "Members and roles",
          "text": "Invite your org mates with a link and organise them with roles and squadrons."
        },
        "ships": {
          "title": "Fleet ships",
          "text": "Every member's public ships in one list you can filter and search."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "See the whole fleet side by side to scale and save it as an image."
        },
        "stats": {
          "title": "Fleet stats",
          "text": "Analyse your fleet by role, size and cargo capacity."
        },
        "allies": {
          "title": "Allies",
          "text": "Ally with other fleets and keep track of who you fly with."
        },
        "discord": {
          "title": "Discord",
          "text": "Post announcements and a weekly digest to your Discord server, and let members join through a role."
        }
      },
      "impressum": {
        "visit": "Visit",
        "ytShipImages": "The Awesome Ship Images in the Hangar Fleetchart view are the work of <a href=\"https://twitter.com/WhyTeeZero\" target=\"_blank\" rel=\"noopener\">YT (Twitter: @WhyTeeZero)</a>.<br>Please visit his Spectrum post (see links below) and give him a upvote.",
        "erkul": "The ship metrics on Fleetyards are modelled on the formulas and readouts of Erkul's DPS Calculator. Thanks to the erkul.games team for sharing their work with the community.",
        "appSignal": "AppSignal provided a sponsored Open Source Account which helps to improve Fleetyards.net even further. Thanks :)",
        "copyright": "The contents and works created by the page operators, on these pages are subject to German copyright. Duplication, processing, distribution and any kind of exploitation outside the limits of Copyright require the written consent of the respective author or creator. Downloads and copies of this page are only for private, non-commercial use. Insofar as the content on This page was not created by the operator, are third-party copyrights respected. In particular, Third-party content as such. Please Contact us if you notice any sort of copyright infringement. We will remove any content immediately as we become aware of such violations.",
        "disclaimer": {
          "p1": "This is an unofficial Star Citizen fansite, not affiliated with the Cloud Imperium group of companies.",
          "p2": "All content on this site not authored by its host or users are property of their respective owners.",
          "p3": "Star Citizen®, Squadron 42®, Roberts Space Industries®, and Cloud Imperium® are registered trademarks of Cloud Imperium Rights LLC. All rights reserved."
        },
        "liabilityInternal": {
          "p1": "The content of out site has been compiled with meticulous care and to the best of our knowledge. However, We cannot assume any liability for the up-to-dateness, completeness or accuracy of any of the pages.",
          "p2": "Pursuant to section 7, para. 1 of the TMG (Telemediengesetz), We are liable for our own content on these pages in accordance with general laws. However, pursuant to sections 8 to 10 of the TMG, We are not under obligation to monitor external information provided or stored on our site. Once We have become aware of a specific infringement of the law, We will immediately remove the content in question. Any liability concerning this matter can only be assumed from the point in time at which the infringement becomes known to us."
        },
        "liabilityExternal": "Our site contains links to websites of third parties (“external links”). As the content of these sites is not under our control, We cannot assume any liability for such external content. In all cases, the provider of information of the linked sites is liable for the content and accuracy of the information provided. At the point in time when the links were placed, no infringements of the law were recognisable to us. As soon as an infringement of the law becomes known to us, We will immediately remove the link in question."
      },
      "privacy": {
        "text": "The use of our site is usually possible without providing any personal data. The collecting of personal data (eg email address) on our sites will be, as far as possible, on a voluntary basis. No personal data will be passed on to third parties without your explicit consent.<br>We point out that data transmission over the Internet (eg when communicating by email) can have security gaps. A complete protection of data against access by third parties is not possible.",
        "p1": "Below you can read about what Information we are using to provide you the services on %{app}. For most parts this only concerns registered Users but please read further to get a full overview.",
        "p2": {
          "headline": "What Information do we use?",
          "text": "Depending on if you are a registered User or only using %{app} as a Guest we use more or less Information from you."
        },
        "p3": {
          "headline": "As a Guest",
          "text": "As a Guest on %{app} we collect the following data:"
        },
        "analytics": {
          "headline": "Usage analytics",
          "basis": "%{app} counts page views to understand which parts of the site are actually used. This runs on our legitimate interest in operating and improving the site, not on consent: the data is collected first-party only, IP addresses are anonymised before they are stored, no cookies or other identifiers are placed on your device, and nothing is shared with advertising networks.",
          "retention": "Individual visits and page views are deleted after one month. Only aggregated counts, which cannot be traced back to a person, are kept beyond that. Deleting your account also deletes the visits recorded for it.",
          "objection": {
            "headline": "How to object",
            "text": "You can object to usage analytics at any time, and we will stop recording it rather than merely hiding it.",
            "user": "Your account setting under Settings is applied to every device you sign in on.",
            "guest": "Without an account you can object here. We also honour the Global Privacy Control signal if your browser sends one."
          }
        }
      },
      "settings": {
        "privacy": {
          "tracking": "When this is enabled we count the pages you visit to see which parts of the site are used. IP addresses are anonymised, nothing is stored on your device, and individual visits are deleted after one month. Turning it off stops the recording entirely.",
          "onlineStatus": "When this is enabled, the members of your fleets and your friends see a dot next to your name while you have FleetYards open. Turning it off hides it from them — nothing else changes, and your last activity is still shown."
        },
        "notifications": {
          "hint": "Pick how each event reaches you. App notifications are collected in your notification center, mail goes to your account's address.",
          "push": {
            "title": "Push notifications",
            "intro": "Get notifications on this device even while FleetYards is closed. Which ones arrive as push is set in the Push column below.",
            "unsupported": "This browser can't receive push notifications. On an iPhone or iPad, add FleetYards to your Home Screen and open it from there.",
            "denied": "Notifications are blocked for FleetYards in this browser. Allow them in the browser's site settings, then reload this page.",
            "on": "Push notifications are on for this device.",
            "off": "Push notifications are off for this device.",
            "device": "%{browser} on %{os}",
            "unknownDevice": "Unknown browser",
            "thisDevice": "(this device)",
            "failed": "Push notifications could not be checked for this device. Reload the page to try again."
          }
        }
      },
      "signup": {
        "blocked": "You have been blocked from FleetYards.net.<br>This can have multiple Reasons.<br>For further Information please Contact us under info ( at ) fleetyards.net"
      },
      "roadmap": {
        "inactive": "This Item was removed from the Roadmap. This is its last location"
      },
      "twoFactor": {
        "backupCodes": "Save a copy of your Backup-Codes. They will only be visible this one time.",
        "disable": "To disable 2-Factor-Auth just enter a valid Token.",
        "enable": " To secure your FleetYards.net Account you can generate 2-Factor-Auth Tokens with Google Authenticator, 1Password or Authy."
      },
      "oauthAuthorize": {
        "requestingAccess": "%{clientName} is requesting access to your account.",
        "scopesIntro": "This application will be able to:"
      },
      "buybackSync": {
        "info": "This reads every page of your RSI buy-back list and replaces the buy-back pledges stored on Fleetyards with it. Your hangar is not touched. Long lists take a few minutes. The sync runs in the background: you can close this window and keep using Fleetyards; just keep the tab open.",
        "unsupported": "Your Fleetyards Sync Extension cannot read buy-back pledges yet. Update it to sync them.",
        "detailsInfo": "The first sync also reads the price and insurance of every pledge, one RSI page each, which can take a quarter of an hour for a long list. Later syncs only read the new ones.",
        "detailsUnsupported": "Update your Fleetyards Sync Extension to read prices and insurance as well.",
        "detailsIncomplete": "Some prices could not be read from RSI. The next sync tries them again.",
        "detailsBackground": "Prices and insurance are now read in the background. You can close this window and keep using Fleetyards; keep this tab open until it finishes.",
        "detailsRunning": "Prices and insurance from the last sync are still being read. A new sync can start once that has finished."
      },
      "addToHangar": {
        "hangarHint": "You own this ship.",
        "wishlistHint": "You want to get this ship later."
      },
      "resetIngame": {
        "info": "A wipe takes away the ships you bought in-game. Move them to your wishlist to buy them again later, or remove them from your hangar. Ships you did not buy in-game stay as they are."
      },
      "syncExtension": {
        "gettingStarted": "To sync your RSI Hangar with Fleetyards you first need to install the Fleetyards Sync Extension for Firefox or Chromium based Browsers.",
        "info": "We will try to match the ships from your RSI Hangar with your existing ships in your Fleetyards Hangar by using the name and the pledge-id. Ships from the RSI Hangar without a match will be added to your Fleetyards Hangar.<br><br>Do you want to continue?",
        "alreadyRunning": "A Hangar Sync is already in progress. Please wait for it to finish.",
        "missingUnmatchedGroup": "Choose the group to file ships the sync cannot find into before you start.",
        "notSyncing": "Not syncing:"
      },
      "setEmail": "To set a password, enable two-factor authentication, or receive email notifications, you need to add an email address to your account. You will receive a confirmation email to verify the address.",
      "oauthApplications": {
        "pendingReview": "This application has been registered and is waiting to be reviewed. It cannot request access until it is approved.",
        "rejected": "This application was refused and cannot request access. Correcting what the reason names puts it back in the queue.",
        "returnedToReview": "Changing the redirect URI or the scopes returns an approved application to review."
      },
      "payouts": {
        "accountFound": "%{username} has a FleetYards account and will be linked to this participant.",
        "accountMissing": "No FleetYards account has this username. Check the spelling, or add them by name below as a guest.",
        "guestHint": "For someone without a FleetYards account. They are listed as a guest.",
        "deleteHint": "Nobody else is on this tour yet, so it can be deleted.",
        "tourInvite": "%{username} invites you to join this tour.",
        "contractReady": "The contract is fulfilled. Open its payout ledger to pay the reward to the contractors.",
        "contractNotReady": "No payout ledger has been opened for this contract yet.",
        "expenseNeedsReview": "An expense counts once whoever manages the ledger has approved it."
      },
      "fleet": {
        "contractCovers": "The art the board shows for each kind of contract. Leave one empty and the built-in image below is used."
      },
      "vehicleLog": {
        "visibility": "Public entries are shown with this ship in your public hangar.",
        "visibilityHidden": "This ship is not listed in your public hangar, so none of its entries are shown there.",
        "empty": "Write down what happened to this ship — only you can see an entry until you make it public.",
        "publicEmpty": "This ship's captain has not shared any log entries yet.",
        "noneForFilter": "No entries match this filter.",
        "unavailable": "This log is not available right now."
      },
      "vehiclePlaque": {
        "supporter": "Every other style is a thank-you to the people who keep Fleetyards running.",
        "keptStyle": "Your plaque keeps its %{style} style, a supporter perk. Saving switches it to %{default}.",
        "credits": {
          "founders": "%{manufacturer} Founders",
          "shipwrights": "%{manufacturer} Shipwrights",
          "designers": "%{manufacturer} Designers",
          "directors": "%{manufacturer} Directors"
        },
        "fromFleet": "From a fleet",
        "classLine": "%{model} by %{manufacturer}",
        "commissioned": "Commissioned from %{shipyard}",
        "launched": "Launched %{date}",
        "launchedAt": "Launched %{date}, %{port}",
        "launchedFrom": "Launched from %{port}",
        "captain": "Captain %{name}",
        "captainOf": "Captain %{name}, %{affiliation}",
        "year": "%{month} %{year}",
        "empty": "No dedication yet. Write one and the ship gets its plaque.",
        "visibility": "Anyone can see the plaque in your public hangar while this ship is public."
      },
      "vehicleOverview": {
        "noLoadouts": "No loadouts yet. Link one from Erkul or SPViewer.",
        "locationPrivate": "Only you can see where your ship is.",
        "galleryReplacesUpload": "Picking a gallery picture replaces the one you uploaded.",
        "galleryEmpty": "This ship has no gallery pictures yet."
      },
      "model": {
        "sectionEmpty": "The %{model} does not have any %{section}."
      }
    }
  }
}
